<template>
  <v-app>
    <TopNav />
    <v-main>
      <router-view />
    </v-main>
    <Footer />
    <Analytics />
  </v-app>
</template>

<script setup>
import TopNav from './components/TopNav.vue';
import Footer from "./components/Footer.vue";
import { Analytics } from '@vercel/analytics/vue';

/*import { useHead } from '@unhead/vue;

useHead({
  title: "Holonet Galactic Encyclopedia – Star Wars Planets & Regions",
  meta: [
    {
      name: "description",
      content:
        "Explore Star Wars planets, regions, and lore in the Holonet Galactic Encyclopedia, powered by Wikidata and Wookieepedia for an immersive, interactive experience.",
    },
    { property: "og:title", content: "Holonet Galactic Encyclopedia" },
    {
      property: "og:description",
      content:
        "Dive into Star Wars planets and regions, enriched with Wikidata and Wookieepedia links for a comprehensive, interactive encyclopedia.",
    },
    { property: "og:url", content: "https://sw-holonet.com" },
    { property: "og:type", content: "website" },
    { name: "twitter:title", content: "Holonet Galactic Encyclopedia" },
    { name: "twitter:description", content: "Explore the Star Wars galaxy with rich data about planets, regions, and lore, powered by Wikidata and Wookieepedia." }
  ],
  script: [
    {
      src: "https://scripts.simpleanalyticscdn.com/latest.js",
      async: true,
    },
  ]
});*/
</script>

<style>
html, body, #app, .v-application {
  height: 100%;
  width: 100%;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.v-btn:hover {
  box-shadow: 0 0 12px rgba(0, 140, 255, 0.7); 
}
/* .v-card {
  border: 1px solid #008cff; 
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
} */

.v-application {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.v-main {
  flex: 1 0 auto;
  margin-top: 0px !important;
  min-height: 0 !important;
  min-height: calc(100vh - 64px - var(--footer-height, 56px)) !important;
  background: url('@/assets/bg_space_seamless.png') repeat center center #000 !important;
  background-size: cover !important;
  overflow: visible !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

/* Make router-view content as wide as possible for the map */
.v-main > * {
  width: 100%;
  max-width: 100vw;
  flex: 1 0 auto;
}

.v-footer {
  flex-shrink: 0;
}

/* Add space between page content and footer */
.main-content {
  padding-bottom: var(--footer-height, 56px);
}

:root {
  --footer-height: 56px;
}

@media (max-width: 600px) {
  :root {
    --footer-height: 72px;
  }
}

.v-application--wrap {
  min-height: 100vh !important;
  height: 100vh !important;
}
</style>
